// extracted by mini-css-extract-plugin
export default {"modalFooter":"CancelInvoiceConfirmationModal_modalFooter__QedRs"};